import { create } from "zustand";

interface ClosedStore {
  closed: boolean;
  toggleClosed: () => void;
  setFalseClose: () => void;
}

const useCloseAllStore = create<ClosedStore>((set) => ({
  closed: false,
  toggleClosed: () => set((state) => ({ closed: !state.closed })),
  setFalseClose: () => set(() => ({closed: false}))
}));

export default useCloseAllStore;
